import React, { useState, useCallback } from "react";
import PropTypes from "prop-types";

export default function DownloadButton({ url, authHeader, filename, className }) {
  const [loading, setLoading] = useState(false);

  const handleDownload = useCallback(async () => {
    if (loading) return;
    setLoading(true);
    try {
      const headers = authHeader ? { Authorization: authHeader } : {};
      const res = await fetch(url, { headers });
      if (!res.ok) throw new Error(`HTTP ${res.status}`);
      const blob = await res.blob();
      const blobUrl = URL.createObjectURL(blob);
      const a = document.createElement("a");
      a.href = blobUrl;
      a.download = filename;
      a.click();
      URL.revokeObjectURL(blobUrl);
    } catch {
      // swallow — next click will retry
    } finally {
      setLoading(false);
    }
  }, [url, authHeader, filename, loading]);

  return (
    <button
      type="button"
      onClick={handleDownload}
      disabled={loading}
      className={`inline-flex items-center justify-center gap-1.5 ${className || ""}`}
    >
      {loading && (
        <svg className="w-3.5 h-3.5 animate-spin" viewBox="0 0 24 24" fill="none">
          <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4" />
          <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4z" />
        </svg>
      )}
      {loading ? "Downloading…" : "Download"}
    </button>
  );
}

DownloadButton.propTypes = {
  url: PropTypes.string.isRequired,
  authHeader: PropTypes.string,
  filename: PropTypes.string.isRequired,
  className: PropTypes.string,
};
